export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: "选美比赛的网络投票，真的会影响最终名次吗？",
    answer:
      "取决于赛制。评委主导型赛事里，网络票数通常只作为人气加分，影响有限；而在评委与票数各半、甚至纯人气排名的赛制中，投票结果可能直接决定名次。看比赛前先确认票数权重，是判断榜单可信度的第一步。",
  },
  {
    question: "票数注水一般会留下哪些明显痕迹？",
    answer:
      "最常见的有三类：新增投票账号注册时间高度集中且缺乏历史互动；在凌晨等非活跃时段出现远超日常的放量；多个平台的票数在同一分钟同步跳涨。单独一项不足以定论，但多项同时出现就值得追问。",
  },
  {
    question: "后援会集资打榜的钱，一般是怎么核算的？",
    answer:
      "规范的做法是把支出拆到最小单位，逐笔附上带时间戳的凭证，并在关键节点公开答疑。较为含糊的做法通常只公示几个汇总条目，粉丝难以核对具体金额与用途。出资前先看账目习惯，比事后追责更有效。",
  },
  {
    question: "为什么凌晨的票数特别容易被质疑？",
    answer:
      "因为真实粉丝的活动时间大多集中在晚间和周末，凌晨属于低活跃时段。如果某个选手的票数偏偏在凌晨大幅跳涨，且缺乏合理的组织说明，就很容易被怀疑是非自然增长。",
  },
  {
    question: "普通人如何判断一份人气榜单可不可信？",
    answer:
      "可以看三件事：主办方是否公开分钟级票数数据、是否说明异常票段的复核方式、是否公布账号结构的统计口径。愿意公开校验过程的榜单，通常比只强调「结果真实有效」的榜单更值得相信。",
  },
  {
    question: "围观打榜争议时，怎样避免被情绪带偏？",
    answer:
      "先区分事实与推断。截图、时间戳、公开票数属于事实；「一定有人刷票」属于推断。把两者分开看，再留意信息源是否完整呈现了上下文，能大幅降低被单方面叙事影响判断的概率。",
  },
];